import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, Input, Button } from '../../components/ui';
import { AlertTriangle, TrendingUp, Users, ArrowRight } from 'lucide-react';
import { cn } from '../../lib/utils';

export function RetentionCalculatorTool() {
  const [startMembers, setStartMembers] = useState('500');
  const [endMembers, setEndMembers] = useState('480');
  const [newMembers, setNewMembers] = useState('50');

  const start = parseInt(startMembers) || 0;
  const end = parseInt(endMembers) || 0;
  const newM = parseInt(newMembers) || 0;

  const retained = end - newM;
  const retentionRate = start > 0 ? (retained / start) * 100 : 0;
  const churnRate = 100 - retentionRate;

  return (
    <div className="grid lg:grid-cols-2 gap-8 text-left">
      <div className="space-y-6">
        <Card className="p-6 space-y-4">
          <h3 className="text-lg font-bold">Retention Parameters (Annual/Period)</h3>
          <div>
            <label className="text-[10px] uppercase font-bold text-gray-400">Members at Start of Period</label>
            <Input type="number" value={startMembers} onChange={e => setStartMembers(e.target.value)} />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-[10px] uppercase font-bold text-gray-400">Members at End</label>
              <Input type="number" value={endMembers} onChange={e => setEndMembers(e.target.value)} />
            </div>
            <div>
              <label className="text-[10px] uppercase font-bold text-gray-400">New Members Added</label>
              <Input type="number" value={newMembers} onChange={e => setNewMembers(e.target.value)} />
            </div>
          </div>
        </Card>
      </div>

      <div className="space-y-4">
         <Card className="p-6 bg-blue-50 border-blue-100 flex items-center justify-between dark:bg-blue-900/20 dark:border-blue-800">
            <div>
              <span className="text-[10px] uppercase font-bold text-blue-600 block mb-1">Retention Rate</span>
              <p className="text-4xl font-black text-blue-700">{retentionRate.toFixed(1)}%</p>
            </div>
            <TrendingUp className="text-blue-400 w-12 h-12 opacity-50" />
         </Card>
         <Card className="p-6 bg-red-50 border-red-100 flex items-center justify-between dark:bg-red-900/20 dark:border-red-800">
            <div>
              <span className="text-[10px] uppercase font-bold text-red-600 block mb-1">Churn Rate</span>
              <p className="text-4xl font-black text-red-700">{churnRate.toFixed(1)}%</p>
            </div>
            <Users className="text-red-400 w-12 h-12 opacity-50" />
         </Card>

         <div className="p-4 bg-[#FFD600] text-black border-2 border-black space-y-2">
           <p className="text-xs font-bold leading-snug">
             Want to boost retention across your chapters? Track member engagement, auto-renew dues via Stripe, and send urgent Pulse alerts before members churn.
           </p>
           <Link
             to="/sign-up"
             className="inline-flex items-center gap-1.5 text-xs font-black uppercase tracking-wider bg-black text-white hover:bg-[#0044FF] px-3 py-1.5 transition-colors cursor-pointer"
           >
             Create Free Organization <ArrowRight className="w-3.5 h-3.5" />
           </Link>
         </div>
      </div>
    </div>
  );
}

